import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailControlSystem } from '../dto/trail-control-system';

@Injectable({
  providedIn: 'root'
})
export class TrailControlSystemService {

  private apiUrl = environment.apiRoot + '/trialcontrolsystem';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(vesselId: number): Observable<TrailControlSystem[]> {
    return this.http.get<TrailControlSystem[]>(this.apiUrl + '/alloftrial?trialId=' + vesselId);
  }

  createControlSystem(trialId: number): Observable<TrailControlSystem> {
    let model = { "id": 0, "trial_id": trialId, "name": "new ControlSystem" };
    return this.http.post<TrailControlSystem>(this.apiUrl + '/new', model);
  }

  updateControlSystem(model: TrailControlSystem): Observable<TrailControlSystem> {
    return this.http.put<TrailControlSystem>(this.apiUrl + '/update', model);
  }

  deleteControlSystem(trialContralSyslId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialControlSysId=' + trialContralSyslId);
  }

}
